import React from 'react';
import ScrollToTop from '../../components/Common/ScrollTop';
import Team from './TeamSection';
import ServiceCounter from './CounterSection';

const ServiceMain = () => {

    return (
        <React.Fragment>
            {/* AboutCounter Start */}
            <ServiceCounter />
            {/* AboutCounter End */}

            {/* AboutVideo Start */}
            {/* <AboutVideo /> */}
            {/* AboutVideo End */}

            {/* Team Section Start */}
            <Team />
            {/* Team Section End */}

            {/* Testimonial Section Start */}
            {/* <Testimonial /> */}
            {/* Testimonial Section End */}

            {/* Blog Section Start */}
            {/* <Blog /> */}
            {/* Blog Section End */}

			{/* scrolltop-start */}
			<ScrollToTop
				scrollClassName="scrollup orange-color"
			/>
			{/* scrolltop-end */}

        </React.Fragment>
    )
}

export default ServiceMain;